import styled, { DefaultTheme } from 'styled-components';

import { utils } from '@desygner/ui-common-components';

import { PRESETS } from './ErrorPage.presets';

const StyledErrorWrapper = styled.div<{
  theme: DefaultTheme;
  isMobile?: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.Color.Neutrals.Paper};
  min-height: calc(100vh - ${({ theme }) => utils.rem(theme.Spacing.Size.XXXLarge)});
  width: 100%;
`;

const StyledErrorImageContainer = styled.div<{
  isMobile?: boolean;
}>`
  position: relative;
  width: ${({ isMobile }) =>
    isMobile ? '100%' : utils.rem(PRESETS.styledErrorImageContainer.width.desktop)};
  overflow: hidden;
  aspect-ratio: 5 / 2;
`;

const StyledErrorMessageWrapper = styled.p<{ theme: DefaultTheme }>`
  max-width: ${utils.rem(PRESETS.styledErrorMessageWrapper.maxWidth)};
  margin-left: auto;
  margin-right: auto;
`;

const StyledErrorButtonContainer = styled.div<{ isMobile: boolean }>`
  & button {
    width: ${({ isMobile }) => (isMobile ? '100%' : 'auto')};
    background: ${({ theme }) => theme.Color.System.Primary};
  }
`;

const StyledFixWrapper = styled.div`
  position: absolute;
  top: var(--page-margin);
  left: var(--page-margin);
`;

export {
  StyledErrorWrapper,
  StyledErrorMessageWrapper,
  StyledErrorImageContainer,
  StyledErrorButtonContainer,
  StyledFixWrapper,
};
